if (!customElements.get("bundle-parent")) {
  class ParentBundle extends HTMLElement {
    constructor() {
      super();
      this.bundles = new Bundles();
      this.bodyContainer = this.querySelector(".product__body");

      this.strings = {
        oos: this.getAttribute("data-string-oos") || "Out of Stock",
        restricted: this.getAttribute("data-string-restricted") || "Product Restricted",
        oneLifetime: this.getAttribute("data-lang-onelifetime") || "Lifetime Limit Reached",
      };
    }

    addEventListeners() {
      const addToCartBtn = this.bundles.container.querySelector(".js--add-to-cart-bundle");
      if (!addToCartBtn) {
        console.warn("No add-to-cart buttons found");
        return;
      }

      if (addToCartBtn.disabled) {
        return;
      }

      if (!this.bundleId) {
        console.warn("No bundle ID found");
        return;
      }

      addToCartBtn.addEventListener("click", async (event) => {
        event.preventDefault();
        await this.bundles.addToCart(this.bundleId);
      });
    }

    disableAddToCartBtn(text) {
      const addToCartBtn = this.bundles.container.querySelector(".js--add-to-cart-bundle");
      if (addToCartBtn) {
        addToCartBtn.textContent = text;
        addToCartBtn.disabled = true;
      }
    }

    applyLifetimeSingleItemUi() {
      const addToCartBtn = this.bundles.container.querySelector(".js--add-to-cart-bundle");
      if (addToCartBtn) {
        addToCartBtn.textContent = this.strings.oneLifetime;
        addToCartBtn.disabled = true;
        addToCartBtn.classList.remove("button--primary");
        addToCartBtn.classList.add("button--primary-outlined");
      }
    }

    async connectedCallback() {
      this.bundles.initializeFromElement(this);
      this.bundles.bundleData = await this.bundles.getBundleAsProduct();
      this.bundleId = this.bundles.bundleData[0]?.id || null;
      this.bundles.productData = await this.bundles.getShopifyProductsData();

      for (const bundle of this.bundles.bundleData) {
        const isBundleRestricted = await this.bundles.getIsBundleRestricted(bundle.id);
        if (isBundleRestricted) {
          console.warn(`Bundle ${bundle.id} contains restricted products. Skipping rendering.`);
          this.disableAddToCartBtn(this.strings.restricted);
        }

        const isBundleOOS = await this.bundles.getIsBundleOOS(bundle.id);
        if (isBundleOOS) {
          console.warn(`Bundle ${bundle.id} is out of stock. Skipping rendering.`);
          this.disableAddToCartBtn(this.strings.oos);
        }

        const getIsBundleTSCRestricted = await this.bundles.getIsBundleTSCRestricted(bundle.id);
        if (getIsBundleTSCRestricted) {
          console.warn(`Bundle ${bundle.id} contains TSC restricted products. Skipping rendering.`);
          this.disableAddToCartBtn(this.strings.restricted);
        }

        const isBundleLifetimeLimited = this.bundles.getIsBundleLifetimeLimited(bundle.id);
        if (isBundleLifetimeLimited) {
          this.applyLifetimeSingleItemUi();
        }

        this.bundles.getShopifyCart();
        this.bundles.createAddToCartobjects(bundle);

        this.bundles.renderPrice(bundle.id);
        this.bundles.renderDCE(bundle.id);
        this.bundles.renderCannabinoidClassification(bundle.id);
        this.bundles.renderPlantType(bundle.id);

        this.bodyContainer.classList.remove("parent-bundle-hide");
      }

      this.addEventListeners();
    }

    disconnectedCallback() {
      this.bundles.disconnectedCallback();
    }
  }

  customElements.define("bundle-parent", ParentBundle);
}
